import { Col, Form, Modal } from "react-bootstrap";
// import "./Modal.scss";
import FloatingInput from "../compoment/ui/FloatingInput";
import Loader from "../compoment/ui/Loader";
import Email from "../compoment/icon/Email";
import LogoBlack from './../assets/img/MOSIDA-black.png'
import { FormEvent, useState } from "react";
import { useForm } from "../constants/useForm";
import { toast } from "react-toastify";

interface SigninModalProps {
  show: boolean;
  onHide: () => void;
  props?: Record<string, unknown>;
  setVerificationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setResetModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const VerificationModal: React.FC<SigninModalProps> = ({
  show,
  onHide,
  props,
  setResetModal,
  setVerificationModal
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { values, handleChange } = useForm({
    email: "",
  });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission

    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      onHide();
      setResetModal(true)
      toast.success("Code verified successfully");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting && <Loader />}
      <Modal
        className="mosidaModal signinModal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header className="pb-0" closeButton></Modal.Header>
        <Modal.Body className="py-5">
          <Col md={10} className="mx-auto">
            <div className="text-center mb-4 pb-md-2 mt-5">
              <img
                className="pointer"
                style={{ width: 140 }}
                src={LogoBlack}
                alt=""
              />
            </div>

            <div className="sectionHeading mb-0 pb-2">
              Check your email
            </div>
            <p className="text-muted mb-4 pb-3">{`Enter the verification code we sent to your email address.`}</p>
            <Form onSubmit={handleSubmit}>
              <FloatingInput
                placeholder="Enter verification code"
                label="Verification code"
                icon={undefined}
                type="text"
                name="code"
                onChange={handleChange}
              />
              <button
                className="btnPrimary w-100 sqaure"
                type="submit"
                disabled={isSubmitting}
              >
                Continue
              </button>
            </Form>

            {/* <div className="dontHaveAccount mt-4">
              {`Don’t have an account?`}{" "}
              <span
                className="text-primary"
                onClick={() => {
                  setForgotPasswordModal(false);
                  setSignupModal(true);
                }}
              >
                Sign up
              </span>
            </div> */}
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VerificationModal;


